/**
 * Team data mapping and merging utilities.
 */

import type { FUSportsTeamCompetitor } from "fansunited-data-layer";
import { deepMerge } from "@/utilities/core/deepMerge";

/**
 * Merges team data from API with constants configuration.
 * Constants data takes precedence and will override API data.
 *
 * @param apiData - Team data from the API (getFootballTeam)
 * @param constantsData - Team configuration from constants (COMPETITORS)
 * @returns Merged team data with constants taking precedence
 *
 * @example
 * ```ts
 * const apiTeam = await getFootballTeam(teamId);
 * const constantsTeam = COMPETITORS[teamId];
 * const mergedTeam = mergeTeamData(apiTeam, constantsTeam);
 * ```
 */
export function mergeTeamData(
    apiData: FUSportsTeamCompetitor,
    constantsData?: Partial<FUSportsTeamCompetitor>
): FUSportsTeamCompetitor {
    if (!constantsData) {
        return apiData;
    }

    return deepMerge(
        apiData as unknown as Record<string, unknown>,
        constantsData as unknown as Record<string, unknown>
    ) as unknown as FUSportsTeamCompetitor;
}
